module.exports = __webpack_public_path__ + "img/product-sticker.276218d8.png";